import { render, staticRenderFns } from "./zhuanzuoxiayoushang.vue?vue&type=template&id=45470448&scoped=true&"
import script from "./zhuanzuoxiayoushang.vue?vue&type=script&lang=js&"
export * from "./zhuanzuoxiayoushang.vue?vue&type=script&lang=js&"
import style0 from "./zhuanzuoxiayoushang.vue?vue&type=style&index=0&id=45470448&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45470448",
  null
  
)

export default component.exports